import React, { useCallback, useEffect, useState } from 'react';
import JournalPanel from '../../ProjectDetail/panels/JournalPanel';
import { apiService } from '../../../services/api';
import { Card } from '../ui';
import { ErrorText, errorText, useNexusProjectRefresh, useTabError } from './shared';

const time = (value) => {
  const ms = value ? new Date(value).getTime() : 0;
  return Number.isNaN(ms) ? 0 : ms;
};

// Plus récentes d'abord : date de l'entrée, puis date de création.
const newestFirst = (a, b) => time(b.entry_date) - time(a.entry_date) || time(b.created_at) - time(a.created_at);

// Journal de bord. Le lien ?entryId= n'ouvre pas l'entrée : JournalPanel n'offre pas de moyen de le faire.
const JournalTab = ({ projectId, project, employees }) => {
  const [entries, setEntries] = useState([]);
  const { error, fail, attempt } = useTabError();

  const load = useCallback(async () => {
    try {
      const data = await apiService.get(`/projects/${projectId}/journal`);
      setEntries(Array.isArray(data) ? data : []);
    } catch (err) {
      fail(`Chargement du journal : ${errorText(err)}`);
    }
  }, [projectId, fail]);

  useEffect(() => {
    setEntries([]);
    load();
  }, [load]);

  useNexusProjectRefresh(projectId, (entity) => {
    if (entity === 'journal') load();
  });

  const addEntry = useCallback((entryData) => attempt("Ajout de l'entrée", async () => {
    const created = await apiService.post(`/projects/${projectId}/journal`, entryData);
    setEntries((prev) => [...prev, created].sort(newestFirst));
    return created;
  }), [attempt, projectId]);

  // Pas de mise à jour locale pendant l'édition : la liste se recharge à la fermeture du formulaire.
  const updateEntry = useCallback((entryId, updateData) => attempt("Mise à jour de l'entrée",
    () => apiService.patch(`/projects/${projectId}/journal/${entryId}`, updateData)), [attempt, projectId]);

  const deleteEntry = useCallback((entryId) => attempt("Suppression de l'entrée", async () => {
    await apiService.delete(`/projects/${projectId}/journal/${entryId}`);
    setEntries((prev) => prev.filter((entry) => entry.id !== entryId));
  }), [attempt, projectId]);

  return (
    <Card>
      <ErrorText className="mb-3">{error}</ErrorText>
      <JournalPanel
        projectId={projectId}
        project={project}
        journalEntries={entries}
        employees={employees}
        onAddEntry={addEntry}
        onUpdateEntry={updateEntry}
        onDeleteEntry={deleteEntry}
        onFormClose={load}
      />
    </Card>
  );
};

export default JournalTab;
